import type { ApolloClient } from '@apollo/client'
import { excludeStandbyQueries } from './helpers/excludeStandbyQueries/excludeStandbyQueries'

/**
 * `watchQuery` default shared by the app client and the Storybook decorator so stories run under the
 * same `notifyOnNetworkStatusChange` behavior as the app. Apollo defaults it to `true`, which would
 * drop every refetch, poll and variable change back into `loading`; the app opts in per query instead.
 */
export const apolloWatchQueryDefaults = { notifyOnNetworkStatusChange: false }

/**
 * Full `defaultOptions` for the real app client. The `mutate.onQueryUpdated` guard keeps a mutation's
 * `refetchQueries` from waking `standby` (skipped) queries — a production concern the Storybook client
 * deliberately omits, since stories mock GraphQL and don't want mutations triggering extra refetches.
 */
export const apolloDefaultOptions = {
  watchQuery: apolloWatchQueryDefaults,
  mutate: { onQueryUpdated: excludeStandbyQueries },
} satisfies ApolloClient.DefaultOptions
